import { IConfigurations } from '@epicuro-next/platform/configuration';

export const NAMESPACE_ONBOARDING = 'onboarding';

export enum OnboardingConfigurationKeys {
  Configuration = 'configuration',
  ShowOnboardingPopupOnInit = 'show-onboarding-popup-on-init',
  ShowSalesOnboarding = 'show-sales-onboarding',
  ShowConsumerOnboarding = 'show-consumer-onboarding',
  ConsumerTutorialLink = 'consumer-tutorial-link',
  SalesTutorialLink = 'sales-tutorial-link',
}

export interface OnboardingConfigurations
  extends IConfigurations<OnboardingConfigurationKeys> {
  // tslint:disable-next-line:prefer-optional
  [OnboardingConfigurationKeys.Configuration]: string | undefined;
  [OnboardingConfigurationKeys.ShowOnboardingPopupOnInit]: boolean;
  [OnboardingConfigurationKeys.ShowSalesOnboarding]: boolean;
  [OnboardingConfigurationKeys.ShowConsumerOnboarding]: boolean;
  [OnboardingConfigurationKeys.ConsumerTutorialLink]: string;
  [OnboardingConfigurationKeys.SalesTutorialLink]: string;
}
